import { useCallback } from 'react';
import { useToast } from '../../../components/ui/use-toast.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';

export type ItemAddedToastProps = {
    quantity: number;
    unit: string;
};

export type UseToastsHook = {
    showUpdateErrorToast: () => void;
    showItemAddedToast: (props: ItemAddedToastProps) => void;
};

export function useToasts(): UseToastsHook {
    const { t } = useLocale('sales-draft');
    const { toast } = useToast();

    return {
        showUpdateErrorToast: useCallback(() => {
            toast({
                title: t(`sales_draft__update_error_toast__title`),
                description: t(`sales_draft__update_error_toast__description`),
                icon: 'warning',
            });
        }, [t, toast]),

        showItemAddedToast: useCallback(
            ({ quantity, unit }: ItemAddedToastProps) => {
                toast({
                    icon: 'success',
                    variant: 'default',
                    title: t('toast__product_added_title', { ns: 'catalog' }),
                    description: t('toast__product_added_body', { ns: 'catalog' })
                        .replace('{{quantity}}', quantity.toString())
                        .replace('{{unit}}', unit)
                        .trim(),
                });
            },
            [t, toast],
        ),
    };
}
